import { FallbackError } from "@core/domain/errors/fallback.error";
import { RouteDatasource } from "@station/data/datasources/route.datasource";
import type { Route, RouteFilter } from "@station/domain/models/route.model";
import type { RouteRepository } from "@station/domain/repositories/route.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class RouteImplRepository implements RouteRepository {
    constructor(
        @inject(RouteDatasource)
        private readonly routeDatasource: RouteDatasource,
    ) {}

    getAllRoute(routeFilter: RouteFilter): ResultAsync<Route, FallbackError> {
        return this.routeDatasource.fetchAllRoute(routeFilter);
    }
}
